import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StartComponent } from './start/start.component';
import { MakeAppointmentContactDetailsComponent } from './make-appointment-contact-details/make-appointment-contact-details.component';
import { MakeAppointmentThankYouComponent } from './make-appointment-thank-you/make-appointment-thank-you.component';
import { TellUsComponent } from './tell-us/tell-us.component';
import { OTPComponent } from './otp/otp.component';
import { IdentifyYourCompanyComponent } from './identify-your-company/identify-your-company.component';
import { CompanyNotFoundComponent } from'./company-not-found/company-not-found.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { CompanyDetailsInfoComponent } from'./company-details-info/company-details-info.component';
import { ConfirmYourCompanyComponent } from'./confirm-your-company/confirm-your-company.component';
import { MultipleCompanyComponent } from'./multiple-company/multiple-company.component';
import { CompanyDetailsComponent } from './company-details/company-details.component';
import { DirectorDetailsComponent } from './director-details/director-details.component';
import { BusinessDetailComponent } from './business-detail/business-detail.component';
import { AboutYourBusinessComponent } from './about-your-business/about-your-business.component';
import { AboutYourBusinessInfoComponent } from './about-your-business-info/about-your-business-info.component';
import { TaxStatusComponent } from './tax-status/tax-status.component';
import { AboutYourTransactionComponent } from './about-your-transaction/about-your-transaction.component';
import { BusinessBankingServiceComponent } from './business-banking-service/business-banking-service.component';
import { UploadDocumentComponent } from './upload-document/upload-document.component';
import { UploadNRICComponent } from './upload-nric/upload-nric.component';
import { SignatureComponent } from './signature/signature.component';
import { SecondDirectorSignatureComponent } from './second-director-signature/second-director-signature.component';
import { SecondDirectorUploadNricComponent } from './second-director-upload-nric/second-director-upload-nric.component';
import { DeclarationComponent } from './declaration/declaration.component';
import { SecondDirectorDeclarationComponent } from './second-director-declaration/second-director-declaration.component';
import { SecondOTPComponent } from './second-otp/second-otp.component';
import { CorrectionRequestComponent } from './correction-request/correction-request.component';
import { SalesAssistedThankYouComponent } from './sales-assisted-thank-you/sales-assisted-thank-you.component';
import { SecondDirectorDetailsComponent } from './second-director-details/second-director-details.component';
import { CompanyConstitutionComponent } from './company-constitution/company-constitution.component';
import { ThankYouApplicationComponent } from './thank-you-application/thank-you-application.component';
import { ThankYouWithoutEkycComponent } from './thank-you-without-ekyc/thank-you-without-ekyc.component';
import { SecondDirectorThankYouApplicationComponent } from './second-director-thank-you-application/second-director-thank-you-application.component';
import { SecondDirectorThankYouWithoutEkycComponent } from './second-director-thank-you-without-ekyc/second-director-thank-you-without-ekyc.component';
import { SecondDirectorCompanyConstitutionComponent } from './second-director-company-constitution/second-director-company-constitution.component';
import { DirectorConfirmComponent } from './director-confirm/director-confirm.component';
import { SecondDirectorConfirmComponent } from './second-director-confirm/second-director-confirm.component';
import { HttpClientModule } from '@angular/common/http';
import { IdentifyExistComponent } from './identify-exist/identify-exist.component';
import { DatePipe, CurrencyPipe } from '@angular/common';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { InfoUpdateYourRecordComponent } from './info-update-your-record/info-update-your-record.component';
import { LastStepComponent } from './last-step/last-step.component';
import { EndLastStepComponent } from './end-last-step/end-last-step.component';
import { SmileyComponent } from './smiley/smiley.component';
import { RedirectingComponent } from './redirecting/redirecting.component';
import { ThankYouDirectorComponent } from './thank-you-director/thank-you-director.component';
import { OneMoreStepWithoutEkycComponent } from './one-more-step-without-ekyc/one-more-step-without-ekyc.component';
import { AppHeaderComponent } from './app-header/app-header.component';
import { AppFooterComponent } from './app-footer/app-footer.component';
import { SignaturePadComponent } from './signature-pad/signature-pad.component';
import { SignatureDropBoxComponent } from './signature-drop-box/signature-drop-box.component';
import { PasscodeComponent } from './passcode/passcode.component';

@NgModule({
  declarations: [
    AppComponent,
    StartComponent,
    MakeAppointmentContactDetailsComponent,
    MakeAppointmentThankYouComponent,
    TellUsComponent,
    OTPComponent,
    IdentifyYourCompanyComponent,
    CompanyNotFoundComponent,
    ThankYouComponent,
    CompanyDetailsInfoComponent,
    CompanyDetailsComponent,
    ConfirmYourCompanyComponent,
    MultipleCompanyComponent,
    DirectorDetailsComponent,
    BusinessDetailComponent,
    AboutYourBusinessComponent,
    AboutYourBusinessInfoComponent,
    TaxStatusComponent,
    AboutYourTransactionComponent,    
    BusinessBankingServiceComponent,
    UploadDocumentComponent,
    UploadNRICComponent,
    SignatureComponent,
    SecondDirectorSignatureComponent,
    SecondDirectorUploadNricComponent,
    DeclarationComponent,
    SecondDirectorDeclarationComponent,
    SecondOTPComponent,
    CorrectionRequestComponent,
    SalesAssistedThankYouComponent,
    SecondDirectorDetailsComponent,
    CompanyConstitutionComponent,
    ThankYouApplicationComponent,
    ThankYouWithoutEkycComponent,
    SecondDirectorThankYouApplicationComponent,
    SecondDirectorThankYouWithoutEkycComponent,
    SecondDirectorCompanyConstitutionComponent,
    DirectorConfirmComponent,
    SecondDirectorConfirmComponent,
    IdentifyExistComponent,
    InfoUpdateYourRecordComponent,
    LastStepComponent,
    EndLastStepComponent,
    SmileyComponent,
    RedirectingComponent,
    ThankYouDirectorComponent,
    OneMoreStepWithoutEkycComponent,
    AppHeaderComponent,
    AppFooterComponent,
    SignaturePadComponent,
    SignatureDropBoxComponent,
    PasscodeComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [DatePipe,AppComponent, {provide: LocationStrategy, useClass: HashLocationStrategy}, CurrencyPipe],
  bootstrap: [AppComponent, AppHeaderComponent, AppFooterComponent ]
})
export class AppModule { }
